export default "__VITE_ASSET__0f388bc5__"